import { isEmpty, isPresent } from '@ember/utils';
import { validatePresence } from 'ember-changeset-validations/validators';
import { isNumber } from 'donor-elf-web/lib/string-utils';
import numberUtils from 'donor-elf-web/lib/number-utils';
import dateUtils from 'donor-elf-web/lib/date-utils';
import { assignSingleProperty } from 'donor-elf-web/lib/object-utils';
import { pledgeOneTimeFrequency } from 'donor-elf-web/lib/pledge-utils';

function decisionYes(changes, content) {
  let decisionMade =
    assignSingleProperty(content, changes, 'decisionMade') || false;
  return (
    decisionMade &&
    assignSingleProperty(content, changes, 'journalDecisionYesNo') === true
  );
}

export default function validateJournalDecisionChange(hasYtdGoalType) {
  return {
    journalContactId: validatePresence({
      presence: true,
      message: "journalContactId can't be blank",
    }),

    journalDecisionJournalGoalId: (
      key,
      newValue,
      oldValue,
      changes,
      content,
    ) => {
      if (decisionYes(changes, content) && isEmpty(newValue)) {
        return "journalDecisionJournalGoalId can't be blank";
      }
      return true;
    },
    journalDecisionDecisionDate: (
      key,
      newValue,
      oldValue,
      changes,
      content,
    ) => {
      let decisionMade =
        assignSingleProperty(content, changes, 'decisionMade') || false;
      if (decisionMade) {
        if (isEmpty(newValue)) {
          return "Decision Date can't be blank";
        } else if (
          dateUtils.serializeToDateOnly(newValue) >
          dateUtils.serializeToDateOnly(new Date())
        ) {
          return "Decision Date can't be in the future";
        }
      }
      return true;
    },

    pledgeAmount: (key, newValue, oldValue, changes, content) => {
      if (
        decisionYes(changes, content) &&
        (!isNumber(newValue) || Number(newValue) <= 0)
      ) {
        return 'Pledge Amount must be positive number';
      }
      return true;
    },
    pledgeFrequency: (key, newValue, oldValue, changes, content) => {
      if (decisionYes(changes, content) && isEmpty(newValue)) {
        return "Pledge Frequency can't be blank";
      }
      return true;
    },
    pledgeStartDate: (key, newValue, oldValue, changes, content) => {
      if (decisionYes(changes, content) && isEmpty(newValue)) {
        return "Pledge Start Date can't be blank";
      }
      return true;
    },
    pledgeEndDate: (key, newValue, oldValue, changes, content) => {
      if (isPresent(newValue)) {
        let startDate = assignSingleProperty(
          content,
          changes,
          'pledgeStartDate',
        );
        if (isPresent(startDate)) {
          let endDateString = dateUtils.serializeToDateOnly(newValue);
          let startDateString = dateUtils.serializeToDateOnly(startDate);
          if (startDateString > endDateString) {
            return "Pledge End Date can't be before Start Date";
          }
        }
      }
      return true;
    },
    pledgeEndDateMonths: (key, newValue, oldValue, changes, content) => {
      let frequency = assignSingleProperty(content, changes, 'pledgeFrequency');
      if (
        decisionYes(changes, content) &&
        frequency === pledgeOneTimeFrequency &&
        !hasYtdGoalType
      ) {
        if (
          !isNumber(newValue) ||
          !numberUtils.isInteger(Number(newValue)) ||
          Number(newValue) <= 0
        ) {
          return '# Months must be a positive whole number';
        }
      }
      return true;
    },
  };
}
